import { call, put, select } from 'redux-saga/effects'
import { getData as apiGetData } from 'api/Api'
import { PermissionLevels } from 'utils/permission'
import {
  setPermissionLevel,
  setId,
  setName,
  setLists
} from '../redux/view'
import {
  set as setSettings
} from '../redux/settings'
import {
  addArray as addCardArray
} from '../redux/cards'
import {
  addArray as addListArray
} from '../redux/lists'
import {
  addArray as addOwnerArray
} from '../redux/owners'
import {
  addArray as addVisitorArray
} from '../redux/visitors'

export default function * fetchView (action) {
  const { userId } = action.payload

  const state = yield select()

  const currentUserId = state.kanbo.currentUser.id

  const { Id, Name, MyBoardOwnerId, Owners, Visitors, VLists, Settings } = yield call(apiGetData, 'MyBoard', { userId })

  const batchedActions = []

  // PermissionLevel
  batchedActions.push(setPermissionLevel({
    permissionLevel:
      MyBoardOwnerId === currentUserId
        ? PermissionLevels.OWNER
        : PermissionLevels.VISITOR
  }))

  // Id
  batchedActions.push(setId({
    id: Id
  }))

  // Name
  batchedActions.push(setName({
    name: Name
  }))

  // Settings
  batchedActions.push(setSettings({
    syncType: Settings.SyncType,
    cardAdderSettings: {
      responsible: Settings.CardAdderSettings.Responsible,
      coworker: Settings.CardAdderSettings.Coworker,
      listId: Settings.CardAdderSettings.ListId
    }
  }))

  // Lists and cards
  const listIds = []
  const lists = []
  const cards = []

  VLists.forEach(VList => {
    const list = {
      id: VList.Id,
      name: VList.Name,
      position: VList.Position,
      settings: {
        color: VList.Settings.Color,
        wipLimit: VList.Settings.WIPLimit
      },
      cards: VList.VCards.map(VCard => {
        cards.push({
          id: VCard.Id,
          cardId: VCard.CardId,
          position: VCard.Position,
        })

        return VCard.Id
      })
    }

    listIds.push(list.id)
    lists.push(list)
  })

  batchedActions.push(addCardArray(cards))
  batchedActions.push(addListArray(lists))
  batchedActions.push(setLists({ lists: listIds }))

  // Users
  batchedActions.push(addOwnerArray(Owners))
  batchedActions.push(addVisitorArray(Visitors))

  yield put(batchedActions)
}
